import { combineReducers } from '@reduxjs/toolkit'

import contents from './ltContentsReducer'
import toast from './ltToastReducer'
import video from './videoSessionSlice'
import clientDetails from '../clients/clientDetails/data/ltClientDetailsReducer'
import messenger from '../messages/data/messagesSlice'

export default combineReducers({
  clientDetails,
  messenger,
  video,
  contents,
  toast,
})
